import React from 'react'
import ReactDOM from 'react-dom'
import MapViewportButton from '../MapViewportButton'

export default function MapLocationFavorite(){
  return ReactDOM.createPortal(<MapViewportButton />, document.getElementById('topbar-map-favorite-location') as HTMLElement)
}


